import { Text } from 'bz-core-controls';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

@inject('draftStore')
@observer
export default class FormulaEditor extends Component {
  @computed
  get PotentialVariables() {
    return Object.values(this.props.draftStore.rawTemplate.get('entityMap') || {})
      .filter(({ data }) => !!data.formulakey)
      .map(({ data }) => data.formulakey);
  }

  render() {
    return (
      <div>
        <Text
          {...this.props}
          skipScrollTo={true}
          src={this.PotentialVariables}
          appendMode="space"
          className="formula-editor"
        />
      </div>
    );
  }
}
